import React, { useRef, useEffect } from "react"

function getPathFromPercentage(percentage, width) {
  const cx = width / 2
  const cy = width / 2
  const r = width / 2

  // Angle in radians for the given percentage
  const angle = percentage * Math.PI * 2

  // Start and end angle
  const startAngle = 0
  const endAngle = startAngle + angle

  // Compute the two points where our wedge intersects the circle
  // These formulas are chosen so that an angle of 0 is at 12 o'clock and positive angles increase clockwise.
  const x1 = cx + r * Math.sin(startAngle)
  const y1 = cy - r * Math.cos(startAngle)
  let x2 = cx + r * Math.sin(endAngle)
  const y2 = cy - r * Math.cos(endAngle)

  // This is a flag for angles larger than than a half circle
  // It is required by the SVG arc drawing component
  let mid = 0
  if (endAngle - startAngle > Math.PI) {
    mid = 1
    // Not possible to get a full circle if we close the arc completely.
    // If we do, the starting point will be the same as the end point and the arc won't be drawn
    // This difference won't be possible to appreciate by human eye
    const maxCx = cx - 0.0001
    if (x2 > maxCx) {
      x2 = maxCx
    }
  }

  // Create and assign path details
  const d =
    `M ${cx},${cy} ` + // Start at circle center
    `L ${x1},${y1} ` + // Draw line to (x1,y1)
    `A ${r},${r} ` + // Draw an arc of radius r
    `0 ${mid} 1 ` + // Arc details...
    `${x2},${y2} ` + // Arc goes to to (x2,y2)
    "Z" // Close path back to (cx,cy)

  return d
}

const CirclePath = ({ className, children, percentage }) => {
  const containerRef = useRef(null)
  const [path, setPath] = React.useState("")

  useEffect(() => {
    if (containerRef.current) {
      const width = containerRef.current.offsetWidth
      const pathData = getPathFromPercentage(percentage, width)
      setPath(pathData)
    }
  }, [percentage])

  return (
    <div className={className} ref={containerRef}>
      <svg>
        <path d={path} />
      </svg>
      {children}
    </div>
  )
}

export default CirclePath
